import React from "react";

interface EmptyStateActionObject {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: EmptyStateActionObject | React.ReactNode;
  className?: string;
}

/**
 * Check if action is an action object with label and onClick.
 */
const isActionObject = (
  action: EmptyStateActionObject | React.ReactNode
): action is EmptyStateActionObject => {
  return (
    action !== null &&
    typeof action === "object" &&
    "label" in action &&
    "onClick" in action
  );
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className = "",
}) => (
  <div className={`text-center py-12 ${className}`}>
    {icon && <div className="text-neutral-400 mb-4">{icon}</div>}
    <h3 className="text-lg font-medium text-neutral-900">{title}</h3>
    {description && (
      <p className="mt-2 text-sm text-neutral-500">{description}</p>
    )}
    {action &&
      (isActionObject(action) ? (
        <button
          onClick={action.onClick}
          className="mt-6 inline-flex items-center gap-x-1.5 px-4 py-2 text-sm font-semibold text-white bg-primary-700 rounded-md hover:bg-primary-800 shadow-sm transition-colors"
        >
          {action.icon}
          {action.label}
        </button>
      ) : (
        <div className="mt-4">{action}</div>
      ))}
  </div>
);
